import type { DeliveryAreaList } from "./index";

/** Single district row from GET /countries/:countryId/districts `data`. */
export interface CountryDistrictApiRow {
  id: number;
  name: string;
  governateId: number;
  zoneId: number;
}

/** Zone object under `included.zones`. */
export interface CountryDistrictZoneIncluded {
  id: number;
  name: string;
  createdAt: string;
}

/**
 * Response body for GET /countries/:countryId/districts.
 * All districts are returned in one response (not paginated).
 */
export interface GetCountryDistrictsApiResponse {
  data: CountryDistrictApiRow[];
  included?: {
    zones: CountryDistrictZoneIncluded[];
  };
}

/** Defensive copy of district rows (API returns a single flat array). */
export function flattenCountryDistrictsPayload(
  data: GetCountryDistrictsApiResponse["data"] | undefined | null,
): CountryDistrictApiRow[] {
  if (!Array.isArray(data)) {
    return [];
  }
  return data;
}

/** Map API rows to `DeliveryAreaList` (core district fields only). */
export function mapCountryDistrictsToDeliveryAreaList(
  rows: CountryDistrictApiRow[],
): DeliveryAreaList[] {
  return rows.map((area) => ({
    id: area.id,
    name: area.name,
    governateId: area.governateId,
    zoneId: area.zoneId,
  }));
}
